import React from "react"
import Button from "../components/Button"
import PriceButton from '../components/PriceButton'
import powerUp from "../images/full-power-program-white-bg.jpg"
import styles from "../styles/fullPowerProgram.module.scss"

class FullPowerProgram extends React.Component {
  constructor(){
    super()
    this.state = {
      haveEthos:false,
      ethosTitle1: '',
      ethosTitle2: '',
      ethosTitle3: '',
      ethosTitle4: '',
      ethosTitle5: '',
    }
  }


  componentDidMount(){
    const finalEthos = localStorage.getItem('haveEthos')
    const ethos1=localStorage.getItem('ethos1Title')
    const ethos2=localStorage.getItem('ethos2Title')
    const ethos3=localStorage.getItem('ethos3Title')
    const ethos4=localStorage.getItem('ethos4Title')
    const ethos5=localStorage.getItem('ethos5Title')

    
    if(finalEthos==='true'){
      this.setState({
        haveEthos:finalEthos,
        ethosTitle1:ethos1,
        ethosTitle2:ethos2,
        ethosTitle3:ethos3,
        ethosTitle4:ethos4,
        ethosTitle5:ethos5,
      })
    }
    
  }



  render(){

    
  return (
    <div className={styles.program}>
      <div className={styles.program_txt}>
        <h2>
          <span className={styles.orange}>Full Power</span> • Program
        </h2>
        <h3>
          <span className={styles.program_txt_txt}>fitness | thought coaching</span> <span className={styles.program_txt_background}>+ challenges</span>
        </h3>
        <p>
          The Full Power Program allows you 24/7 access to all my Fitness and
          Thought Coaching videos <strong>PLUS the curated 7-week challenge</strong>. By signing
          up for the Full Power Program, you’ll always be included in the
          challenges as we move forward!
        </p>
        <p className={styles.program_txt__features}>FEATURES INCLUDED</p>
        <ul className={styles.program_txt_list}>
          <li>Full Access to Fitness Video Library</li>
          <li>Full Access to Thought Coaching Video Library</li>
          <li className={styles.program_txt__features_block}><span className={styles.program_txt__features_listBlock}>Full Access to Challenges!</span></li>
        </ul>
        <div className={styles.program_btns}>
          <div>
          {this.state.haveEthos?  
              <PriceButton
              price={"19.95"}
            href={`https://member.empowerofyou.com/checkout/?add-to-cart=4741&ethos1=${this.state.ethosTitle1}&ethos2=${this.state.ethosTitle2}&ethos3=${this.state.ethosTitle3}&ethos4=${this.state.ethosTitle4}&ethos5=${this.state.ethosTitle5}`}
            backgroundColor={"#FFBE76"}
              outlineColor={"#FFBE76"}
              label={"Pay Monthly"}
              length={"month"}
              fontSize={"18px"}
            />
            : 
            <PriceButton
              price={"19.95"}
              href={`https://member.empowerofyou.com/checkout/?add-to-cart=4741`}
              backgroundColor={"#FFBE76"}
              outlineColor={"#FFBE76"}
              label={"Pay Monthly"}
              length={"month"}
              fontSize={"18px"}
            />
          }
            <p>$0.66 per day</p>
          </div>
          <div>
          {this.state.haveEthos?  
                <PriceButton
                price={"219.45"}
                href={`https://member.empowerofyou.com/checkout/?add-to-cart=4744&ethos1=${this.state.ethosTitle1}&ethos2=${this.state.ethosTitle2}&ethos3=${this.state.ethosTitle3}&ethos4=${this.state.ethosTitle4}&ethos5=${this.state.ethosTitle5}`}
                backgroundColor={"#FFBE76"}
                outlineColor={"#FFBE76"}
                label={"Pay Yearly"}
                length={"year"}
                fontSize={"18px"}
              />
            : 
            <PriceButton
              price={"219.45"}
              href={"https://member.empowerofyou.com/checkout/?add-to-cart=4744"}
              backgroundColor={"#FFBE76"}
              outlineColor={"#FFBE76"}
              label={"Pay Yearly"}
              length={"year"}
              fontSize={"18px"}
            />
          }
            <p>$0.60 per day</p>
          </div>
        </div>
      </div>
      <div className={styles.program_img}>
        <img src={powerUp} alt="shawna and friend training" />
      </div>
    </div>
  )
}
}

export default FullPowerProgram
